import {
	Component,
	OnInit,
	ViewEncapsulation,
	trigger,
	state,
	style,
	transition,
	animate
} from '@angular/core';

import { SpeakerService } from '../speaker.service';


@Component({
	selector: 'summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('toggleDetails', [
			state('void', style({
				'max-height': '0px'
			})),
			state('*', style({
				'max-height': '2000px'
			})),
			transition(':enter, :leave', animate('600ms ease-in-out'))
		])
	]
})

export class SummaryComponent implements OnInit {
	
	speakers: any;
	
	constructor(private speakerSrv: SpeakerService) {
		this.speakerSrv.speakersChange.subscribe(speakers => {
			this.speakers = speakers;
			this.updateStats();
		});
	}
	
	public details: boolean = false;
	public summaryDetailsStatement: any[];
	
	SummaryStatement: string;
	
	private rowLabels: string[][] = [
		['Role', 'Residuals'],
		['Gender', 'Age', 'L1', 'Proficiency', 'Gender:Age', 'Gender:L1', 'Age:L1', 'Gender:Proficiency', 'Age:Proficiency', 'L1:Proficiency', 'Gender:Age:L1', 'Gender:Age:Proficiency', 'Gender:L1:Proficiency', 'Age:L1:Proficiency', 'Gender:Age:L1:Proficiency', 'Residuals']
	];
	
	ngOnInit(): void {
	}
	
	updateStats() {
		let self = this;
		let clonedSpeakerArr = this.speakers.map((speaker) => {
			return Object.assign({}, speaker);
		});
		
		clonedSpeakerArr.sort((one, two) => {
			return one["ID"].localeCompare(two["ID"]);
		});
		let freqs = [];
		for (let i = 0; i < clonedSpeakerArr.length; i++) {
			freqs.push(clonedSpeakerArr[i]['relative_freq']);
		}
		
		console.log(freqs.length);
		self.speakerSrv.doTest(freqs).subscribe((res) => {
			// console.log(res['_body']);
			let intro = "The analysis was performed using the Trinity Lancaster Corpus, which consist of almost " +
				(self.speakerSrv.state['words'] / 1000000).toFixed(0) + " million running words from 1,883 L2 and 134 L1 speakers." +
				" It focused on the sociolinguistic variation in the use of '" + self.speakerSrv.term + "'.<br /><br /><br />";
			let allRes = JSON.parse(res['_body']);
			this.SummaryStatement = intro + SummaryComponent.getSummary(allRes);
			this.summaryDetailsStatement = SummaryComponent.getDetails(allRes, this.rowLabels);
		});
	}
	
	
	showDetails() {
		this.details = !this.details;
	}
	
	static getDetails(interactions: any, rowLabels: string[][]) {
		let output = [];
		for (let i = 0; i < interactions.length; i++) {
			let t;
			t = interactions[i][0];
			let table = [];
			let rowIdx = 0;
			while (true) {
				let row = [rowLabels[i][rowIdx]];
				for (let j = 0; j < t.length; j++) {
					if (t[j][rowIdx]) {
						if (i == 0) {
							if (rowIdx == 0) {
								if (j == t.length - 1) {
									row.push(t[j][rowIdx].toFixed(4))
								} else {
									row.push(t[j][rowIdx].toFixed(3))
								}
							} else {
								row.push(t[j][rowIdx].toFixed(3))
							}
						} else {
							row.push(t[j][rowIdx].toFixed(3))
						}
					} else {
						row.push(null);
					}
				}
				table.push(row);
				rowIdx++;
				if (t[0].length == rowIdx)
					break;
			}
			output.push(table);
		}
		return output;
	}
	
	static getSummary(allInteractions: any) {
		let roleInteraction = allInteractions[0][0][4][0];
		let interactions = allInteractions[1][0][4];
		
		let found = false;
		for (let i = 0; i < interactions.length; i++) {
			if (interactions[i] < 0.05) {
				found = true;
				break;
			}
		}
		if (roleInteraction < 0.025 || found) {
			let interacStr = "Statistical analysis revealed the effect of the following variable(s):<br /><br />";
			if (roleInteraction < 0.025)
				interacStr += "• Role<br />";
			if (interactions[0] < 0.05)
				interacStr += "• Gender<br />";
			if (interactions[1] < 0.05)
				interacStr += "• Age<br />";
			if (interactions[2] < 0.05)
				interacStr += "• L1<br />";
			if (interactions[3] < 0.05)
				interacStr += "• Proficiency<br />";
			if (interactions[4] < 0.05)
				interacStr += "• Combination of Gender and Age</br>";
			if (interactions[5] < 0.05)
				interacStr += "• Combination of Gender and L1</br>";
			if (interactions[6] < 0.05)
				interacStr += "• Combination of Age and L1</br>";
			if (interactions[7] < 0.05)
				interacStr += "• Combination of Gender and Proficiency</br>";
			if (interactions[8] < 0.05)
				interacStr += "• Combination of Age and Proficiency</br>";
			if (interactions[9] < 0.05)
				interacStr += "• Combination of L1 and Proficiency</br>";
			if (interactions[10] < 0.05)
				interacStr += "• Combination of Gender, Age and L1</br>";
			if (interactions[11] < 0.05)
				interacStr += "• Combination of Gender, Age and Proficiency</br>";
			if (interactions[12] < 0.05)
				interacStr += "• Combination of Gender, L1 and Proficiency</br>";
			if (interactions[13] < 0.05)
				interacStr += "• Combination of Age, L1 and Proficiency</br>";
			if (interactions[14] < 0.05)
				interacStr += "• Gender, Age, L1 and Proficiency</br>";
			return interacStr;
		} else {
			return "Statistical analysis didn't reveal any significant effect.";
		}
	}
}


// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/summary/summary.component.ts